module.exports = __webpack_public_path__ + "static/media/34.cb392b60.JPG";